import React from 'react';
import { raise } from '..';
import { DEFAULT_TIMEOUT } from '../raise/constants';
import { default as Toast } from './Toast';
import { raiseToastProps } from './types';

const raiseToast = ({
  message,
  type = 'info',
  duration = DEFAULT_TIMEOUT,
  location = 'bottom-end',
}: raiseToastProps) => {
  raise(<Toast message={message} type={type} />, { location, duration });
};

export default raiseToast;
